import { apiClient } from './api';

interface LoginRequest {
  email: string;
  password: string;
  tenantId?: string;
}

interface LoginResponse {
  accessToken: string;
  refreshToken: string;
  tokenType: string;
  expiresIn: number;
  user: {
    id: string;
    email: string;
    firstName?: string;
    lastName?: string;
    tenantId: string;
    roles: string[];
  };
}

interface RefreshTokenResponse {
  accessToken: string;
  refreshToken: string;
}

interface RegisterRequest {
  email: string;
  password: string;
  tenantId: string;
  firstName?: string;
  lastName?: string;
}

interface RegisterResponse {
  userId: string;
  email: string;
  tenantId: string;
}

interface ForgotPasswordRequest {
  email: string;
}

interface ResetPasswordRequest {
  email: string;
  token: string;
  newPassword: string;
  confirmPassword: string;
}

class AuthService {
  async login(credentials: LoginRequest): Promise<LoginResponse> {
    return await apiClient.post<LoginResponse>('/auth/login', credentials);
  }

  async register(data: RegisterRequest): Promise<RegisterResponse> {
    return await apiClient.post<RegisterResponse>('/auth/register', data);
  }

  async forgotPassword(data: ForgotPasswordRequest): Promise<void> {
    await apiClient.post('/auth/forgot-password', data);
  }

  async resetPassword(data: ResetPasswordRequest): Promise<void> {
    await apiClient.post('/auth/reset-password', data);
  }

  async logout(): Promise<void> {
    await apiClient.post('/auth/logout');
  }

  async refreshToken(refreshToken: string): Promise<RefreshTokenResponse> {
    return await apiClient.post<RefreshTokenResponse>('/auth/refresh', {
      refreshToken,
    });
  }

  async getCurrentUser(): Promise<any> {
    return await apiClient.get('/users/me');
  }
}

export const authService = new AuthService();
